import * as actions from '../../actions/types';
import { combineReducers } from 'redux';

const subscriptionId = (state = null, action) => {
    switch (action.type) {
        case actions.IE_SIGN_UP_FORM_SUBMIT:
            return action.data.level.id;
        case actions.IE_SIGN_UP_FORM_SUBMIT_FAILURE:
            return null;
        default:
            return state;
    }
};

const price = (state = null, action) => {
    switch (action.type) {
        case actions.IE_SIGN_UP_FORM_SUBMIT:
            return action.data.level.price;
        case actions.IE_SIGN_UP_FORM_SUBMIT_FAILURE:
            return null;
        default:
            return state;
    }
};

const userForm = (state = null, action) => {
    switch (action.type) {
        case actions.IE_SIGN_UP_FORM_SUBMIT:
            return action.data.info;
        case actions.IE_SIGN_UP_FORM_SUBMIT_FAILURE:
            return null;
        default:
            return state;
    }
};

const stripe = (state = null, action) => {
    switch (action.type) {
        case actions.CHECKOUT_PAYMENT_FORM_SUBMIT:
            return action.params.stripe || {};
        case actions.CHECKOUT_PAYMENT_ERROR:
            return null;
        default:
            return state;
    }
}

const type = (state = null, action) => {
    switch (action.type) {
        case actions.IE_SIGN_UP_FORM_SHOW:
            return action.action;
        default:
            return state;
    }
}


const appReducer = combineReducers({
    price,
    subscriptionId,
    stripe,
    type,
    userForm,
});

const rootReducer = (state, action) => {
    if (action.type === actions.CHECKOUT_INIT) {
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;